import React from "react";

const Pagination = ({ totalItems, currentPage, itemsPerPage, onPageChange, siblingCount = 1 }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  // if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const leftSibling = Math.max(currentPage - siblingCount, 2);
    const rightSibling = Math.min(currentPage + siblingCount, totalPages - 1);

    pages.push(1);

    if (leftSibling > 2) {
      pages.push("...");
    }

    for (let i = leftSibling; i <= rightSibling; i++) {
      pages.push(i);
    }

    if (rightSibling < totalPages - 1) {
      pages.push("...");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex flex-col items-center !mb-10">
      {/* Showing info */}
      <span className="text-sm text-gray-700">
        Showing <span className="font-semibold text-gray-900">{(currentPage - 1) * itemsPerPage + 1}</span> to <span className="font-semibold text-gray-900">{Math.min(currentPage * itemsPerPage, totalItems)}</span> of <span className="font-semibold text-gray-900">{totalItems}</span> Entries
      </span>

      {/* Pagination controls */}
      <div className="inline-flex !mt-2 xs:mt-0">
        {/* Prev */}
        <button className="flex items-center justify-center !px-4 h-10 text-base font-medium text-white rounded-s cursor-pointer bg-[#008080] hover:bg-[#009999] disabled:bg-[#006666] disabled:cursor-default" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
          Prev
        </button>

        {/* Page numbers */}
        {pageNumbers.map((page, idx) =>
          page === "..." ? (
            <span key={idx} className="flex items-center justify-center !px-4 h-10 text-base font-medium text-white cursor-default bg-[#008080]">
              ...
            </span>
          ) : (
            <button key={idx} className={`flex items-center justify-center !px-4 h-10 text-base font-medium text-white cursor-pointer ${currentPage === page ? "bg-[#006666]" : "bg-[#008080] hover:bg-[#009999]"}  disabled:cursor-default`} disabled={currentPage === page} onClick={() => onPageChange(page)}>
              {page}
            </button>
          ),
        )}

        {/* Next */}
        <button className="flex items-center justify-center !px-4 h-10 text-base font-medium text-white rounded-e cursor-pointer bg-[#008080] hover:bg-[#009999] disabled:bg-[#006666] disabled:cursor-default" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
